import React from "react";
import PropTypes from "prop-types";

import SelectBodyTypeRadioButton from "./SelectBodyTypeRadioButton";
import DropDownVariantButton from "../DropDown/DropDownVariantButton";

import { getOptionKey } from "../../utils/select";

const SelectVariantButton = ({
  showArrow = true,
  withRadio,
  options,
  label,
  value,
  placeholder,
  onChange,
  buttonProps,
  labels,
  parentNode,
  boundaryRect,
  isTranslateLabels,
  ...restProps
}) => {
  const handleChange = (item, indexOption, indexGroup) => {
    onChange(getOptionKey(Array.isArray(item) ? item[indexGroup] : item), indexGroup);
  };

  const key = getOptionKey(value);
  const labelOptionActive = (
    label ?? options.find((o) => getOptionKey(o) === key)?.label ?? placeholder
  );

  return (
    <DropDownVariantButton
      showArrow={showArrow}
      buttonProps={buttonProps}
      label={labelOptionActive}
      parentNode={parentNode}
      boundaryRect={boundaryRect}
      {...restProps}
    >
      {
        ({hide}) => {
          return (
            <SelectBodyTypeRadioButton
              withRadio={withRadio}
              isTranslateLabels={isTranslateLabels}
              labels={labels}
              options={options}
              value={value}
              onSelect={(item, indexOption, indexGroup, e) => {
                handleChange(item, indexOption, indexGroup);
                hide(e);
              }}
            />
          );
        }
      }
    </DropDownVariantButton>
  );
};

SelectVariantButton.propTypes = {
  options: PropTypes.array,
  value: PropTypes.any,
  onChange: PropTypes.func,
  onClick: PropTypes.func,
  containerStyle: PropTypes.string,
};

export default SelectVariantButton;
